import { render, staticRenderFns } from "./acenter.vue?vue&type=template&id=12fa435b&scoped=true&"
import script from "./acenter.vue?vue&type=script&lang=js&"
export * from "./acenter.vue?vue&type=script&lang=js&"
import style0 from "./acenter.vue?vue&type=style&index=0&id=12fa435b&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "12fa435b",
  null
  
)

export default component.exports